/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomerVerificationError, getSmsSendingEndpoint, getVerifySmsEndpoint, SmsSendingInfo } from 'cpnl-common';
import { Error, WithDefaultCpIntegrationErrors } from '@cp-shared-19/common-utilities';
import { parseErrorResponse } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { AxiosError } from 'axios';

export const handleSendSms = async (
    successCallback: (result: SmsSendingInfo) => void,
    errorCallback: (error: CustomAxiosError) => void,
): Promise<void> => {
    try {
        const response = await CpDataApi.get(getSmsSendingEndpoint());
        successCallback(response.data);
    } catch (error) {
        errorCallback({ error } as CustomAxiosError);
    }
};

export const handleSubmitForm = async (
    smsCode: string,
    successCallback: () => void,
    errorCallback: (error: Error<WithDefaultCpIntegrationErrors<CustomerVerificationError>>) => void,
): Promise<void> => {
    try {
        await CpDataApi.post(getVerifySmsEndpoint(), { smsCode });
        successCallback();
    } catch (error) {
        errorCallback(parseErrorResponse<CustomerVerificationError>(error as AxiosError));
    }
};

export type CustomAxiosError = {
    error: {
        response?: {
            status?: number;
            data?: {
                response?: {
                    code?: string;
                    message?: string;
                    status?: string;
                };
                code?: string;
                message?: string;
                status?: number;
            };
        };
    };
};
